import { CareTeamDocument } from '@/api/catchAll/careTeamDocuments/types'
// nosemgrep: no-legacy-api-store
import apiStore from '@/legacy/store/modules/apiBuilder'

export const useCareTeamDocumentApi = apiStore<CareTeamDocument>(
  'careTeamDocumentApi',
  '/api/care_team_documents',
  {
    transformData: (d: { data: CareTeamDocument[] }) => d,
  }
)
